// extracted by mini-css-extract-plugin
module.exports = {"chart":"WHOChart_chart__214KG","shadeFade":"WHOChart_shadeFade__qsFrd","slideIn":"WHOChart_slideIn__2RMwl"};